/**
 * Company Type Enum
 * @readonly
 * @enum {string}
 * @property {string} LEASING - Leasing company type
 * @property {string} DEALER - Dealer company type
 * @property {string} FLOORING - Flooring company type
 * @property {string} RENTAL - Rental company type
 * @property {string} SELF_INSPECTION - Self inspection company type
 */
export enum CompanyType {
  LEASING = 'LEASING',
  DEALER = 'DEALER',
  FLOORING = 'FLOORING',
  RENTAL = 'RENTAL',
  SELF_INSPECTION = 'SELF_INSPECTION',
}

/**
 * Enum for fields by which a location can be sorted.
 * @enum {string}
 */
export enum LocationSortField {
  id = 'id',
  createdAt = 'createdAt',
  name = 'name',
  status = 'status',
  state = 'state',
  address = 'address',
  city = 'city',
}

/**
 * Enum for fields by which a company can be sorted.
 * @enum {string}
 */
export enum CompanySortField {
  id = 'id',
  createdAt = 'createdAt',
  name = 'name',
  status = 'status',
  type = 'type',
}

/**
 * Company Status Enum
 * @readonly
 * @enum {string}
 * @property {string} ACTIVE - Active company status
 * @property {string} TRIAL - Trial company status
 * @property {string} SUBSCRIPTION - Subscription company status
 * @property {string} BLOCKED - Blocked company status
 * @property {string} DELETED - Deleted company status
 */
export enum StatusCompany {
  ACTIVE = 'ACTIVE',
  TRIAL = 'TRIAL',
  SUBSCRIPTION = 'SUBSCRIPTION',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
}
